import React, { useState } from "react";
import { useMyQuestions } from "@/features/profile";
import { QuestionResponse } from "@/entities/support/api/questions-api";
import { MyQuestionsDetail } from "./MyQuestionsDetail";

/**
 * 내 문의 섹션 컴포넌트
 * 문의 목록 조회 및 상세보기/수정
 */
export const MyQuestionsSection = () => {
  const { questions, isLoading, error, refetch } = useMyQuestions();
  const [selectedQuestion, setSelectedQuestion] = useState<QuestionResponse | null>(null);

  if (isLoading) {
    return (
      <div className="p-8 text-center">
        <p className="text-gray-500">로딩 중...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-8 text-center">
        <p className="text-red-500">{error}</p>
      </div>
    );
  }

  if (selectedQuestion) {
    return (
      <MyQuestionsDetail
        question={selectedQuestion}
        onBack={() => {
          setSelectedQuestion(null);
          refetch(); // 목록 새로 고침
        }}
        onUpdateSuccess={() => {
          refetch(); // 업데이트 후 목록 새로 고침
        }}
      />
    );
  }

  if (questions.length === 0) {
    return (
      <div className="p-8 text-center">
        <p className="text-gray-500">문의가 없습니다</p>
      </div>
    );
  }

  return (
    <div className="w-full bg-white">
      {/* 테이블 헤더 */}
      <div className="w-full border-t border-b border-gray-900">
        <div className="w-full px-6 py-3 flex items-center gap-14 text-gray-500 text-sm font-normal">
          <div className="w-12 text-center">No</div>
          <div className="w-20">상태</div>
          <div className="w-24">문의 유형</div>
          <div className="flex-1">제목</div>
          <div className="w-20">공개여부</div>
          <div className="w-24">작성 시간</div>
        </div>
      </div>

      {/* 테이블 행 */}
      <div className="w-full">
        {questions.map((question, index) => (
          <div
            key={question.id}
            onClick={() => setSelectedQuestion(question)}
            className="w-full px-6 py-3 flex items-center gap-14 bg-white border-b border-gray-200 hover:bg-gray-50 cursor-pointer transition-colors text-sm"
          >
            <div className="w-12 text-center text-gray-900 font-normal">
              {questions.length - index}
            </div>
            <div className="w-20">
              <span
                className={`px-2 py-1 text-xs font-semibold rounded inline-block ${
                  question.comment
                    ? "bg-blue-100 text-blue-700"
                    : "bg-gray-100 text-gray-700"
                }`}
              >
                {question.comment ? "답변완료" : "답변대기"}
              </span>
            </div>
            <div className="w-24 text-gray-900 truncate font-normal">
              {question.category}
            </div>
            <div className="flex-1 text-gray-900 truncate font-normal">
              {question.title}
            </div>
            <div className="w-20 text-gray-900 font-normal">
              {question.is_public ? "공개" : "비공개"}
            </div>
            <div className="w-24 text-gray-900 font-normal">
              {new Date(question.created_at).toLocaleDateString("ko-KR")}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
